import { INHERITANCE_CALCULATION_REQUEST_URL, SURVIVAL_PENSION_REQUEST_URL } from './url.constants';

export const SEND_NOEMAIL_NOTIFICATION_MESSAGE = {
    [SURVIVAL_PENSION_REQUEST_URL]: 'Acabas de ingresar una solicitud de pensión de sobrevivencia',
    [INHERITANCE_CALCULATION_REQUEST_URL]: 'Acabas de ingresar una solicitud de pensión de herencia',
};
